const classes = {
  groupLink: {
    color: (theme) => theme.palette.text.primary,
    fontSize: (theme) => theme.typography.pxToRem(13),
    fontWeight: (theme) => theme.typography.fontWeightBold,
    '&:hover': {
      color: (theme) => theme.palette.text.primary,
    },
  },
  tooltip: {
    backgroundColor: 'rgba(97, 97, 97, 0.9)',
    '& a': {
      color: '#FFF',
    },
  },
  differentTimezone: {
    color: '#F56A00',
  },
  vehicleGroup: {
    fontSize: (theme) => theme.typography.pxToRem(13),
    fontWeight: (theme) => theme.typography.fontWeightBold,
    maxHeight: '100%',
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
  },
  location: {
    fontSize: (theme) => theme.typography.pxToRem(13),
    fontWeight: (theme) => theme.typography.fontWeightMedium,
    maxHeight: '100%',
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
  },
  serviceArea: {
    fontSize: (theme) => theme.typography.pxToRem(13),
    maxHeight: '100%',
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
  },
  vehicle: {
    alignItems: 'flex-start !important',
    display: 'flex',
    flexDirection: 'column',
    fontSize: (theme) => theme.typography.pxToRem(13),
    maxWidth: 250,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
  },
  timezoneIcon: {
    color: '#F56A00',
    fontSize: (theme) => theme.typography.pxToRem(10),
    marginLeft: '3px',
  },
  vehicleTitle: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: (theme) => theme.typography.pxToRem(11),
  },
  timezoneContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  timezone: {
    lineHeight: (theme) => theme.typography.pxToRem(11),
  },
  selectedGroup: {
    backgroundColor: (theme) => theme.palette.primary.main,
    '& a': {
      color: (theme) => theme.palette.common.white,
      '&:hover': {
        color: (theme) => theme.palette.common.white,
        fontWeight: 'bold',
      },
    },
  },
  group: {
    height: '100%',
    maxHeight: 65,
    overflow: 'hidden',
    padding: '0',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    width: '100%',
    whiteSpace: 'nowrap',
  },
  calendarSidebar: {
    borderRight: '1px solid #E0E0E0',
    backgroundColor: '#fbfbfb',
    display: 'flex',
    height: 54,
  },
  sidebarColumn: {
    alignItems: 'center',
    color: (theme) => theme.palette.text.primary,
    display: 'flex',
    fontSize: (theme) => theme.typography.pxToRem(12),
    fontWeight: (theme) => theme.typography.fontWeightMedium,
    justifyContent: 'center',
    maxHeight: '100%',
    maxWidth: '100%',
    textAlign: 'center',
  },
  sidebarFirstColumn: {
    borderRight: '1px solid #E0E0E0',
  },
  vgColumn: {
    borderRight: '1px solid #E0E0E0',
    justifyContent: 'flex-start !important',
  },
  vgInfo: {
    fontSize: (theme) => theme.typography.pxToRem(13),
  },
  calendarContainer: {
    boxShadow: '0px 3px 6px #00000019',
    '& .rct-header-root': {
      backgroundColor: '#FFF',
      border: '0',

      '& .rct-calendar-header': {
        border: 0,
        color: (theme) => theme.palette.text.primary,

        '& div:first-child': {
          '& .rct-dateHeader': {
            backgroundColor: '#FFF',
            borderBottom: '1px solid #E0E0E0',
          },
        },
        '& div:last-child': {
          '& .rct-dateHeader': {
            backgroundColor: '#FFF',
            borderBottom: 'none',
            borderLeft: '1px solid #E0E0E0',
          },
        },
      },
    },
    '& .rct-outer': {
      backgroundColor: '#FFF',
      borderColor: '#E0E0E0',
      borderWidth: '1px 1px 1px 0px',
      height: 35,
      '& .rct-sidebar': {
        border: 'none',
        color: (theme) => theme.palette.text.primary,

        '& .rct-sidebar-row': {
          backgroundColor: '#FFF',
          borderColor: '#E0E0E0',
          borderRight: '1px solid #E0E0E0',
          color: (theme) => theme.palette.text.primary,
          fontSize: (theme) => theme.typography.pxToRem(13),
          textAlign: 'center',
        },
      },
    },
  },
};

export default classes;
